module.exports = {
  "id": "9786b19f-a5b0-463e-b96e-53b4dbc259d4",
  "gtmIds": [
    "GTM-P7DDCC8J",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.foundersgrubandpub.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}